'use no memo';

import { getTrafficSource } from '@local/utils';
import { MAX_LENGTH } from './constants';
import { getRestaurantIdFromUrl } from './url';
import { isValidString } from './validation';

/**
 * **prefer `getTrafficSource`**. This is to be used in contexts where the restaurant id
 * is not easily readable from state or context.
 */
export function readCnChannelWithImpliedRestaurantId() {
  const restaurantId = getRestaurantIdFromUrl();

  if (typeof restaurantId !== 'string') {
    return null;
  }

  return getTrafficSource(restaurantId);
}

export function getCanSetPartnerChannel(
  channel: string | undefined | null,
  existingChannel: string | undefined | null
): boolean {
  return (
    !!channel &&
    channel !== existingChannel &&
    isValidString(channel) &&
    channel.length <= MAX_LENGTH.urlParam
  );
}
